module.exports = __webpack_public_path__ + "img/overseasBackground.b0ea7ba1.png";